// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  ClawPassAdminGrantClawPassData,
  ClawPassAdminGrantClawPassError,
  ClawPassAdminGrantClawPassResponse,
  ClawPassGetMyClawPassStatusData,
  ClawPassGetMyClawPassStatusError,
  ClawPassGetMyClawPassStatusResponse,
  ClawPassGetMyCurrentCycleLedgerData,
  ClawPassGetMyCurrentCycleLedgerError,
  ClawPassGetMyCurrentCycleLedgerResponse,
  ClawPassListMyClawPassLedgerData,
  ClawPassListMyClawPassLedgerError,
  ClawPassListMyClawPassLedgerResponse,
  CouponAdminServiceChangeCouponTemplateStatusData,
  CouponAdminServiceChangeCouponTemplateStatusError,
  CouponAdminServiceChangeCouponTemplateStatusResponse,
  CouponAdminServiceCreateCouponTemplateData,
  CouponAdminServiceCreateCouponTemplateError,
  CouponAdminServiceCreateCouponTemplateResponse,
  CouponAdminServiceGetCouponTemplateData,
  CouponAdminServiceGetCouponTemplateError,
  CouponAdminServiceGetCouponTemplateResponse,
  CouponAdminServiceListCouponTemplatesData,
  CouponAdminServiceListCouponTemplatesError,
  CouponAdminServiceListCouponTemplatesResponse,
  CouponAdminServiceListProductsData,
  CouponAdminServiceListProductsError,
  CouponAdminServiceListProductsResponse,
  CouponAdminServiceUpdateCouponTemplateData,
  CouponAdminServiceUpdateCouponTemplateError,
  CouponAdminServiceUpdateCouponTemplateResponse,
  CouponsGetAvailableCouponsData,
  CouponsGetAvailableCouponsError,
  CouponsGetAvailableCouponsResponse,
  CouponsListMyCouponsData,
  CouponsListMyCouponsError,
  CouponsListMyCouponsResponse,
  CreditCodesAdminCreateData,
  CreditCodesAdminCreateError,
  CreditCodesAdminCreateResponse,
  CreditCodesAdminGetData,
  CreditCodesAdminGetError,
  CreditCodesAdminGetResponse,
  CreditCodesAdminListData,
  CreditCodesAdminListError,
  CreditCodesAdminListResponse,
  CreditCodesAdminUpdateData,
  CreditCodesAdminUpdateError,
  CreditCodesAdminUpdateResponse,
  CreditsAddRewardData,
  CreditsAddRewardError,
  CreditsAddRewardResponse,
  CreditsAdminBatchGetCreditsData,
  CreditsAdminBatchGetCreditsError,
  CreditsAdminBatchGetCreditsResponse,
  CreditsAdminBatchUpdateCreditsData,
  CreditsAdminBatchUpdateCreditsError,
  CreditsAdminListCreditRecordsData,
  CreditsAdminListCreditRecordsError,
  CreditsAdminListCreditRecordsResponse,
  CreditsAdminUpdateCreditsData,
  CreditsAdminUpdateCreditsError,
  CreditsAdminUpdateCreditsResponse,
  CreditsGetCostByAppData,
  CreditsGetCostByAppError,
  CreditsGetCostByAppResponse,
  CreditsGetCostData,
  CreditsGetCostError,
  CreditsGetCostResponse,
  CreditsGetExpiringCreditsData,
  CreditsGetExpiringCreditsError,
  CreditsGetExpiringCreditsResponse,
  CreditsGetMyCreditsData,
  CreditsGetMyCreditsError,
  CreditsGetMyCreditsResponse,
  CreditsGetMyFirstCreditsData,
  CreditsGetMyFirstCreditsError,
  CreditsGetMyFirstCreditsResponse,
  CreditsGetRealTimeRewardData,
  CreditsGetRealTimeRewardError,
  CreditsGetRealTimeRewardResponse,
  CreditsGetTaskCostData,
  CreditsGetTaskCostError,
  CreditsGetTaskCostResponse,
  CreditsGetTotalRewardData,
  CreditsGetTotalRewardError,
  CreditsGetTotalRewardResponse,
  CreditsListMyRecordsData,
  CreditsListMyRecordsError,
  CreditsListMyRecordsResponse,
  CreditsUpdateCreditsData,
  CreditsUpdateCreditsError,
  CreditsUpdateCreditsResponse,
  EnterpriseRechargeAdminCreateRechargeData,
  EnterpriseRechargeAdminCreateRechargeError,
  EnterpriseRechargeAdminCreateRechargeResponse,
  EnterpriseRechargeAdminDeliverItemsData,
  EnterpriseRechargeAdminDeliverItemsError,
  EnterpriseRechargeAdminDeliverItemsResponse,
  EnterpriseRechargeAdminFinanceConfirmData,
  EnterpriseRechargeAdminFinanceConfirmError,
  EnterpriseRechargeAdminFinanceConfirmResponse,
  EnterpriseRechargeAdminGetDeliveryReportDataData,
  EnterpriseRechargeAdminGetDeliveryReportDataError,
  EnterpriseRechargeAdminGetDeliveryReportDataResponse,
  EnterpriseRechargeAdminGetRechargeData,
  EnterpriseRechargeAdminGetRechargeError,
  EnterpriseRechargeAdminGetRechargeResponse,
  EnterpriseRechargeAdminGetReconciliationReportDataData,
  EnterpriseRechargeAdminGetReconciliationReportDataError,
  EnterpriseRechargeAdminGetReconciliationReportDataResponse,
  EnterpriseRechargeAdminListRechargesData,
  EnterpriseRechargeAdminListRechargesError,
  EnterpriseRechargeAdminListRechargesResponse,
  EnterpriseRechargeAdminValidateUsersData,
  EnterpriseRechargeAdminValidateUsersError,
  EnterpriseRechargeAdminValidateUsersResponse,
  MarketingActivitiesClaimCouponsData,
  MarketingActivitiesClaimCouponsError,
  MarketingActivitiesClaimCouponsResponse,
  MarketingActivityAdminServiceChangeMarketingActivityStatusData,
  MarketingActivityAdminServiceChangeMarketingActivityStatusError,
  MarketingActivityAdminServiceChangeMarketingActivityStatusResponse,
  MarketingActivityAdminServiceCreateMarketingActivityData,
  MarketingActivityAdminServiceCreateMarketingActivityError,
  MarketingActivityAdminServiceCreateMarketingActivityResponse,
  MarketingActivityAdminServiceGetDispatchProgressData,
  MarketingActivityAdminServiceGetDispatchProgressError,
  MarketingActivityAdminServiceGetDispatchProgressResponse,
  MarketingActivityAdminServiceGetMarketingActivityData,
  MarketingActivityAdminServiceGetMarketingActivityError,
  MarketingActivityAdminServiceGetMarketingActivityResponse,
  MarketingActivityAdminServiceListMarketingActivitiesData,
  MarketingActivityAdminServiceListMarketingActivitiesError,
  MarketingActivityAdminServiceListMarketingActivitiesResponse,
  MarketingActivityAdminServiceUpdateMarketingActivityData,
  MarketingActivityAdminServiceUpdateMarketingActivityError,
  MarketingActivityAdminServiceUpdateMarketingActivityResponse,
  MemberCreditsBatchConfigureMemberCreditsData,
  MemberCreditsBatchConfigureMemberCreditsError,
  MemberCreditsBatchConfigureMemberCreditsResponse,
  MemberCreditsBatchGetMemberCreditsInfoData,
  MemberCreditsBatchGetMemberCreditsInfoError,
  MemberCreditsBatchGetMemberCreditsInfoResponse,
  MemberCreditsGetMemberCreditsInfoData,
  MemberCreditsGetMemberCreditsInfoError,
  MemberCreditsGetMemberCreditsInfoResponse,
  NexusGetAvailableNexusData,
  NexusGetAvailableNexusError,
  NexusGetAvailableNexusResponse,
  NexusGetMyCatalystData,
  NexusGetMyCatalystError,
  NexusGetMyCatalystResponse,
  NexusGetMyNexusHistoryData,
  NexusGetMyNexusHistoryError,
  NexusGetMyNexusHistoryResponse,
  NexusGetOrCreateMyBonusCodeData,
  NexusGetOrCreateMyBonusCodeError,
  NexusGetOrCreateMyBonusCodeResponse,
  NexusGetUnregisterAlertData,
  NexusGetUnregisterAlertError,
  NexusGetUnregisterAlertResponse,
  NexusRedeemCodeData,
  NexusRedeemCodeError,
  NexusRedeemCodeResponse,
  NexusValidateBonusCodeData,
  NexusValidateBonusCodeError,
  NexusValidateBonusCodeResponse,
  OrdersAckOrderData,
  OrdersAckOrderError,
  OrdersAckOrderResponse,
  OrdersCreateData,
  OrdersCreateError,
  OrdersCreateInvoiceData,
  OrdersCreateInvoiceError,
  OrdersCreateResponse,
  OrdersExportPartnerCodeOrderData,
  OrdersExportPartnerCodeOrderError,
  OrdersExportPartnerCodeOrderResponse,
  OrdersGetData,
  OrdersGetError,
  OrdersGetPartnerCodeOrderStatsData,
  OrdersGetPartnerCodeOrderStatsError,
  OrdersGetPartnerCodeOrderStatsResponse,
  OrdersGetProductWithOptionData,
  OrdersGetProductWithOptionError,
  OrdersGetProductWithOptionResponse,
  OrdersGetResponse,
  OrdersGetStateData,
  OrdersGetStateError,
  OrdersGetStateResponse,
  OrdersListHistoryData,
  OrdersListHistoryError,
  OrdersListHistoryResponse,
  OrdersListPartnerCodeOrderData,
  OrdersListPartnerCodeOrderError,
  OrdersListPartnerCodeOrderResponse,
  OrdersListProductsData,
  OrdersListProductsError,
  OrdersListProductsResponse,
  OrdersListProductsWithOptionsData,
  OrdersListProductsWithOptionsError,
  OrdersListProductsWithOptionsResponse,
  PackagesAdminCreateData,
  PackagesAdminCreateError,
  PackagesAdminDeleteData,
  PackagesAdminDeleteError,
  PackagesAdminListData,
  PackagesAdminListError,
  PackagesAdminListResponse,
  PackagesGetConcurrencyData,
  PackagesGetConcurrencyError,
  PackagesGetConcurrencyResponse,
  PackagesListData,
  PackagesListError,
  PackagesListResponse,
  ProductsAdminServiceCreateProductAdminData,
  ProductsAdminServiceCreateProductAdminError,
  ProductsAdminServiceCreateProductAdminResponse,
  ProductsAdminServiceGetProductAdminData,
  ProductsAdminServiceGetProductAdminError,
  ProductsAdminServiceGetProductAdminResponse,
  ProductsAdminServiceListProductsAdminData,
  ProductsAdminServiceListProductsAdminError,
  ProductsAdminServiceListProductsAdminResponse,
  ProductsAdminServiceSetProductStatusData,
  ProductsAdminServiceSetProductStatusError,
  ProductsAdminServiceUpdateProductAdminData,
  ProductsAdminServiceUpdateProductAdminError,
  ProductsAdminServiceUpdateProductAdminResponse,
  SubscriptionsAdminBatchGetData,
  SubscriptionsAdminBatchGetError,
  SubscriptionsAdminBatchGetResponse,
  SubscriptionsCancelMySubscriptionData,
  SubscriptionsCancelMySubscriptionError,
  SubscriptionsCancelSubscriptionChangeData,
  SubscriptionsCancelSubscriptionChangeError,
  SubscriptionsCancelSubscriptionChangeResponse,
  SubscriptionsChangeSubscriptionData,
  SubscriptionsChangeSubscriptionError,
  SubscriptionsChangeSubscriptionResponse,
  SubscriptionsGetChangePreviewData,
  SubscriptionsGetChangePreviewError,
  SubscriptionsGetChangePreviewResponse,
  SubscriptionsGetManagementPortalData,
  SubscriptionsGetManagementPortalError,
  SubscriptionsGetManagementPortalResponse,
  SubscriptionsGetMyExpiredSubscriptionData,
  SubscriptionsGetMyExpiredSubscriptionError,
  SubscriptionsGetMyExpiredSubscriptionResponse,
  SubscriptionsGetMySubscriptionData,
  SubscriptionsGetMySubscriptionError,
  SubscriptionsGetMySubscriptionResponse,
  TrialsAdminUpdateData,
  TrialsAdminUpdateError,
  TrialsAdminUpdateResponse,
  TrialsBatchGetData,
  TrialsBatchGetError,
  TrialsBatchGetResponse,
  TrialsGetData,
  TrialsGetError,
  TrialsGetResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Grant a claw pass benefit package to a user
 */
export const clawPassAdminGrantClawPass = <ThrowOnError extends boolean = false>(
  options: Options<ClawPassAdminGrantClawPassData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawPassAdminGrantClawPassResponse,
    ClawPassAdminGrantClawPassError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/claw-pass/grant',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const couponAdminServiceListCouponTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<CouponAdminServiceListCouponTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CouponAdminServiceListCouponTemplatesResponse,
    CouponAdminServiceListCouponTemplatesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/coupon-templates',
    ...options,
  });
};

/**
 * Immutable after create: name, grant_type, discount_type.
 * Mutable via UpdateCouponTemplate: see §9.1.2 in design doc.
 */
export const couponAdminServiceCreateCouponTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CouponAdminServiceCreateCouponTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CouponAdminServiceCreateCouponTemplateResponse,
    CouponAdminServiceCreateCouponTemplateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/coupon-templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const couponAdminServiceGetCouponTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CouponAdminServiceGetCouponTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CouponAdminServiceGetCouponTemplateResponse,
    CouponAdminServiceGetCouponTemplateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/coupon-templates/{id}',
    ...options,
  });
};

export const couponAdminServiceUpdateCouponTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CouponAdminServiceUpdateCouponTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    CouponAdminServiceUpdateCouponTemplateResponse,
    CouponAdminServiceUpdateCouponTemplateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/coupon-templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const couponAdminServiceChangeCouponTemplateStatus = <ThrowOnError extends boolean = false>(
  options: Options<CouponAdminServiceChangeCouponTemplateStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CouponAdminServiceChangeCouponTemplateStatusResponse,
    CouponAdminServiceChangeCouponTemplateStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/coupon-templates/{id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取credit code列表
 */
export const creditCodesAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<CreditCodesAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditCodesAdminListResponse, CreditCodesAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/code',
    ...options,
  });
};

/**
 * 创建credit code
 */
export const creditCodesAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<CreditCodesAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreditCodesAdminCreateResponse,
    CreditCodesAdminCreateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取credit code
 */
export const creditCodesAdminGet = <ThrowOnError extends boolean = false>(
  options: Options<CreditCodesAdminGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<CreditCodesAdminGetResponse, CreditCodesAdminGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/code/{code}',
    ...options,
  });
};

/**
 * 更新credit code
 */
export const creditCodesAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CreditCodesAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreditCodesAdminUpdateResponse,
    CreditCodesAdminUpdateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/code/{credit_code.code}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取 credit 记录
 */
export const creditsAdminListCreditRecords = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsAdminListCreditRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsAdminListCreditRecordsResponse,
    CreditsAdminListCreditRecordsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/records',
    ...options,
  });
};

/**
 * 批量获取用户 credit 详情
 */
export const creditsAdminBatchGetCredits = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsAdminBatchGetCreditsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsAdminBatchGetCreditsResponse,
    CreditsAdminBatchGetCreditsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/users',
    ...options,
  });
};

/**
 * 批量修改用户 credits 数量
 */
export const creditsAdminBatchUpdateCredits = <ThrowOnError extends boolean = false>(
  options: Options<CreditsAdminBatchUpdateCreditsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, CreditsAdminBatchUpdateCreditsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/users/update/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 修改用户 credits 数量
 */
export const creditsAdminUpdateCredits = <ThrowOnError extends boolean = false>(
  options: Options<CreditsAdminUpdateCreditsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreditsAdminUpdateCreditsResponse,
    CreditsAdminUpdateCreditsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/credits/users/{user_id}/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 列表查询充值记录
 */
export const enterpriseRechargeAdminListRecharges = <ThrowOnError extends boolean = false>(
  options?: Options<EnterpriseRechargeAdminListRechargesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    EnterpriseRechargeAdminListRechargesResponse,
    EnterpriseRechargeAdminListRechargesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges',
    ...options,
  });
};

/**
 * 创建充值记录
 */
export const enterpriseRechargeAdminCreateRecharge = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminCreateRechargeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminCreateRechargeResponse,
    EnterpriseRechargeAdminCreateRechargeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 验证用户账号是否存在
 */
export const enterpriseRechargeAdminValidateUsers = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminValidateUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminValidateUsersResponse,
    EnterpriseRechargeAdminValidateUsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges/validate-users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取充值记录详情
 */
export const enterpriseRechargeAdminGetRecharge = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminGetRechargeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    EnterpriseRechargeAdminGetRechargeResponse,
    EnterpriseRechargeAdminGetRechargeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges/{id}',
    ...options,
  });
};

/**
 * 执行交付
 */
export const enterpriseRechargeAdminDeliverItems = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminDeliverItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminDeliverItemsResponse,
    EnterpriseRechargeAdminDeliverItemsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges/{id}/deliver',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 财务确认到款
 */
export const enterpriseRechargeAdminFinanceConfirm = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminFinanceConfirmData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminFinanceConfirmResponse,
    EnterpriseRechargeAdminFinanceConfirmError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/enterprise-recharges/{id}/finance-confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const marketingActivityAdminServiceListMarketingActivities = <ThrowOnError extends boolean = false>(
  options?: Options<MarketingActivityAdminServiceListMarketingActivitiesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MarketingActivityAdminServiceListMarketingActivitiesResponse,
    MarketingActivityAdminServiceListMarketingActivitiesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities',
    ...options,
  });
};

export const marketingActivityAdminServiceCreateMarketingActivity = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivityAdminServiceCreateMarketingActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MarketingActivityAdminServiceCreateMarketingActivityResponse,
    MarketingActivityAdminServiceCreateMarketingActivityError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const marketingActivityAdminServiceGetMarketingActivity = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivityAdminServiceGetMarketingActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    MarketingActivityAdminServiceGetMarketingActivityResponse,
    MarketingActivityAdminServiceGetMarketingActivityError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities/{id}',
    ...options,
  });
};

export const marketingActivityAdminServiceUpdateMarketingActivity = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivityAdminServiceUpdateMarketingActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    MarketingActivityAdminServiceUpdateMarketingActivityResponse,
    MarketingActivityAdminServiceUpdateMarketingActivityError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const marketingActivityAdminServiceGetDispatchProgress = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivityAdminServiceGetDispatchProgressData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    MarketingActivityAdminServiceGetDispatchProgressResponse,
    MarketingActivityAdminServiceGetDispatchProgressError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities/{id}/dispatch-progress',
    ...options,
  });
};

export const marketingActivityAdminServiceChangeMarketingActivityStatus = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivityAdminServiceChangeMarketingActivityStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MarketingActivityAdminServiceChangeMarketingActivityStatusResponse,
    MarketingActivityAdminServiceChangeMarketingActivityStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/marketing-activities/{id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const packagesAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<PackagesAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<PackagesAdminListResponse, PackagesAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/packages',
    ...options,
  });
};

export const packagesAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<PackagesAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, PackagesAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/packages/step1',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const packagesAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<PackagesAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, PackagesAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/packages/{id}',
    ...options,
  });
};

export const productsAdminServiceListProductsAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<ProductsAdminServiceListProductsAdminData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsAdminServiceListProductsAdminResponse,
    ProductsAdminServiceListProductsAdminError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/product-management',
    ...options,
  });
};

export const productsAdminServiceCreateProductAdmin = <ThrowOnError extends boolean = false>(
  options: Options<ProductsAdminServiceCreateProductAdminData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ProductsAdminServiceCreateProductAdminResponse,
    ProductsAdminServiceCreateProductAdminError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/product-management',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const productsAdminServiceGetProductAdmin = <ThrowOnError extends boolean = false>(
  options: Options<ProductsAdminServiceGetProductAdminData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ProductsAdminServiceGetProductAdminResponse,
    ProductsAdminServiceGetProductAdminError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/product-management/{id}',
    ...options,
  });
};

/**
 * Update replaces all editable product fields from the request.
 */
export const productsAdminServiceUpdateProductAdmin = <ThrowOnError extends boolean = false>(
  options: Options<ProductsAdminServiceUpdateProductAdminData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    ProductsAdminServiceUpdateProductAdminResponse,
    ProductsAdminServiceUpdateProductAdminError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/product-management/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Soft "delete": flip status between valid/invalid. Hard delete is not
 * exposed because `orders.product_id` and `subscriptions.product_id`
 * reference this row and would break historic lookups.
 */
export const productsAdminServiceSetProductStatus = <ThrowOnError extends boolean = false>(
  options: Options<ProductsAdminServiceSetProductStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ProductsAdminServiceSetProductStatusError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/product-management/{id}:setStatus',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const couponAdminServiceListProducts = <ThrowOnError extends boolean = false>(
  options?: Options<CouponAdminServiceListProductsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CouponAdminServiceListProductsResponse,
    CouponAdminServiceListProductsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/products',
    ...options,
  });
};

/**
 * 获取客户交付单数据（用于导出）
 */
export const enterpriseRechargeAdminGetDeliveryReportData = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminGetDeliveryReportDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminGetDeliveryReportDataResponse,
    EnterpriseRechargeAdminGetDeliveryReportDataError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/reports/delivery/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取财务对账单数据（用于导出）
 */
export const enterpriseRechargeAdminGetReconciliationReportData = <ThrowOnError extends boolean = false>(
  options: Options<EnterpriseRechargeAdminGetReconciliationReportDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnterpriseRechargeAdminGetReconciliationReportDataResponse,
    EnterpriseRechargeAdminGetReconciliationReportDataError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/reports/reconciliation/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const subscriptionsAdminBatchGet = <ThrowOnError extends boolean = false>(
  options?: Options<SubscriptionsAdminBatchGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SubscriptionsAdminBatchGetResponse,
    SubscriptionsAdminBatchGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/subscriptions/batch',
    ...options,
  });
};

export const trialsAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TrialsAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TrialsAdminUpdateResponse, TrialsAdminUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/admin/v1/trials/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get the current user's ledger entries for the current billing cycle
 * (today's cycle as computed by clawPassCycleStartAt). No input; returns every
 * record under the latest ledger row. Returns an empty list when the user has
 * no ledger for the current cycle yet. Each entry intentionally carries only
 * the fields needed by the client UI (amount / session_name / created_at).
 */
export const clawPassGetMyCurrentCycleLedger = <ThrowOnError extends boolean = false>(
  options?: Options<ClawPassGetMyCurrentCycleLedgerData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawPassGetMyCurrentCycleLedgerResponse,
    ClawPassGetMyCurrentCycleLedgerError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/claw-pass/current-cycle-ledger',
    ...options,
  });
};

/**
 * List current user's claw pass ledger entries
 */
export const clawPassListMyClawPassLedger = <ThrowOnError extends boolean = false>(
  options?: Options<ClawPassListMyClawPassLedgerData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawPassListMyClawPassLedgerResponse,
    ClawPassListMyClawPassLedgerError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/claw-pass/ledger',
    ...options,
  });
};

/**
 * Get current user's claw pass status, quota and billing cycle
 */
export const clawPassGetMyClawPassStatus = <ThrowOnError extends boolean = false>(
  options?: Options<ClawPassGetMyClawPassStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawPassGetMyClawPassStatusResponse,
    ClawPassGetMyClawPassStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/claw-pass/status',
    ...options,
  });
};

export const couponsGetAvailableCoupons = <ThrowOnError extends boolean = false>(
  options?: Options<CouponsGetAvailableCouponsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CouponsGetAvailableCouponsResponse,
    CouponsGetAvailableCouponsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/coupons/available',
    ...options,
  });
};

export const couponsListMyCoupons = <ThrowOnError extends boolean = false>(
  options?: Options<CouponsListMyCouponsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CouponsListMyCouponsResponse, CouponsListMyCouponsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/coupons/my',
    ...options,
  });
};

/**
 * 发放积分奖励
 */
export const creditsAddReward = <ThrowOnError extends boolean = false>(
  options: Options<CreditsAddRewardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CreditsAddRewardResponse, CreditsAddRewardError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/add-reward',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 通用计价接口，支持多业务域
 */
export const creditsGetCost = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetCostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditsGetCostResponse, CreditsGetCostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/cost',
    ...options,
  });
};

export const creditsGetCostByApp = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetCostByAppData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditsGetCostByAppResponse, CreditsGetCostByAppError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/cost-by-app',
    ...options,
  });
};

export const creditsGetExpiringCredits = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetExpiringCreditsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsGetExpiringCreditsResponse,
    CreditsGetExpiringCreditsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/expiring',
    ...options,
  });
};

/**
 * 获取实时积分奖励
 */
export const creditsGetRealTimeReward = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetRealTimeRewardData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsGetRealTimeRewardResponse,
    CreditsGetRealTimeRewardError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/get-real-time-reward',
    ...options,
  });
};

/**
 * 获取邀请活动奖励总数
 */
export const creditsGetTotalReward = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetTotalRewardData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsGetTotalRewardResponse,
    CreditsGetTotalRewardError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/get-total-reward',
    ...options,
  });
};

/**
 * 获取本人的 credits
 */
export const creditsGetMyCredits = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetMyCreditsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditsGetMyCreditsResponse, CreditsGetMyCreditsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/me',
    ...options,
  });
};

/**
 * 获取我的 credit 记录
 */
export const creditsListMyRecords = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsListMyRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditsListMyRecordsResponse, CreditsListMyRecordsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/records',
    ...options,
  });
};

export const creditsGetMyFirstCredits = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetMyFirstCreditsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    CreditsGetMyFirstCreditsResponse,
    CreditsGetMyFirstCreditsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/sign_up/me',
    ...options,
  });
};

export const creditsGetTaskCost = <ThrowOnError extends boolean = false>(
  options?: Options<CreditsGetTaskCostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreditsGetTaskCostResponse, CreditsGetTaskCostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/tasks/cost',
    ...options,
  });
};

/**
 * 修改用户 credits 数量
 */
export const creditsUpdateCredits = <ThrowOnError extends boolean = false>(
  options: Options<CreditsUpdateCreditsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CreditsUpdateCreditsResponse, CreditsUpdateCreditsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/credits/users/{user_id}/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ClaimCoupons issues coupons from active user_triggered marketing activities
 * whose audience matches the current user. Idempotent per activity/template.
 */
export const marketingActivitiesClaimCoupons = <ThrowOnError extends boolean = false>(
  options: Options<MarketingActivitiesClaimCouponsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MarketingActivitiesClaimCouponsResponse,
    MarketingActivitiesClaimCouponsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/marketing-activities/claim',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const nexusGetAvailableNexus = <ThrowOnError extends boolean = false>(
  options?: Options<NexusGetAvailableNexusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NexusGetAvailableNexusResponse,
    NexusGetAvailableNexusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/available',
    ...options,
  });
};

/**
 * Get-or-create self-service bonus code. Domestic-only.
 */
export const nexusGetOrCreateMyBonusCode = <ThrowOnError extends boolean = false>(
  options: Options<NexusGetOrCreateMyBonusCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    NexusGetOrCreateMyBonusCodeResponse,
    NexusGetOrCreateMyBonusCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/bonus/my',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const nexusValidateBonusCode = <ThrowOnError extends boolean = false>(
  options: Options<NexusValidateBonusCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    NexusValidateBonusCodeResponse,
    NexusValidateBonusCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/bonus/validate/{code}',
    ...options,
  });
};

export const nexusGetMyCatalyst = <ThrowOnError extends boolean = false>(
  options?: Options<NexusGetMyCatalystData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<NexusGetMyCatalystResponse, NexusGetMyCatalystError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/catalyst/me',
    ...options,
  });
};

export const nexusRedeemCode = <ThrowOnError extends boolean = false>(
  options: Options<NexusRedeemCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<NexusRedeemCodeResponse, NexusRedeemCodeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/codes/redeem',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查看任务列表
 */
export const nexusGetMyNexusHistory = <ThrowOnError extends boolean = false>(
  options?: Options<NexusGetMyNexusHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NexusGetMyNexusHistoryResponse,
    NexusGetMyNexusHistoryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/history',
    ...options,
  });
};

export const nexusGetUnregisterAlert = <ThrowOnError extends boolean = false>(
  options?: Options<NexusGetUnregisterAlertData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NexusGetUnregisterAlertResponse,
    NexusGetUnregisterAlertError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/nexus/unregister/alert',
    ...options,
  });
};

/**
 * 创建订单
 */
export const ordersCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrdersCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<OrdersCreateResponse, OrdersCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 主动确认订单
 */
export const ordersAckOrder = <ThrowOnError extends boolean = false>(
  options: Options<OrdersAckOrderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<OrdersAckOrderResponse, OrdersAckOrderError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/ack',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查询订单历史
 */
export const ordersListHistory = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersListHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<OrdersListHistoryResponse, OrdersListHistoryError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/history',
    ...options,
  });
};

/**
 * 开具发票
 */
export const ordersCreateInvoice = <ThrowOnError extends boolean = false>(
  options: Options<OrdersCreateInvoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, OrdersCreateInvoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/invoice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListPartnerCodeOrder 查询使用了当前用户合作码的所有订单
 */
export const ordersListPartnerCodeOrder = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersListPartnerCodeOrderData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OrdersListPartnerCodeOrderResponse,
    OrdersListPartnerCodeOrderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/partner_code/list',
    ...options,
  });
};

/**
 * ExportPartnerCodeOrder 导出当前用户合作码下的全部订单为 Excel，返回文件下载 URL
 */
export const ordersExportPartnerCodeOrder = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersExportPartnerCodeOrderData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OrdersExportPartnerCodeOrderResponse,
    OrdersExportPartnerCodeOrderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/partner_code/list/export',
    ...options,
  });
};

/**
 * GetPartnerCodeOrderStats 返回当前用户合作码关联订单的金额统计
 */
export const ordersGetPartnerCodeOrderStats = <ThrowOnError extends boolean = false>(
  options: Options<OrdersGetPartnerCodeOrderStatsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OrdersGetPartnerCodeOrderStatsResponse,
    OrdersGetPartnerCodeOrderStatsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/partner_code/stats',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查询产品列表
 */
export const ordersListProducts = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersListProductsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<OrdersListProductsResponse, OrdersListProductsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/products',
    ...options,
  });
};

export const ordersListProductsWithOptions = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersListProductsWithOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OrdersListProductsWithOptionsResponse,
    OrdersListProductsWithOptionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/products/filter',
    ...options,
  });
};

export const ordersGetProductWithOption = <ThrowOnError extends boolean = false>(
  options: Options<OrdersGetProductWithOptionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OrdersGetProductWithOptionResponse,
    OrdersGetProductWithOptionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/products/filter/{product_id}',
    ...options,
  });
};

/**
 * 查询订单状态
 */
export const ordersGetState = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersGetStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<OrdersGetStateResponse, OrdersGetStateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/state',
    ...options,
  });
};

/**
 * 查询订单
 */
export const ordersGet = <ThrowOnError extends boolean = false>(options: Options<OrdersGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<OrdersGetResponse, OrdersGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/orders/{id}',
    ...options,
  });
};

export const packagesList = <ThrowOnError extends boolean = false>(
  options?: Options<PackagesListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<PackagesListResponse, PackagesListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/packages',
    ...options,
  });
};

export const packagesGetConcurrency = <ThrowOnError extends boolean = false>(
  options?: Options<PackagesGetConcurrencyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    PackagesGetConcurrencyResponse,
    PackagesGetConcurrencyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/packages/concurrency',
    ...options,
  });
};

export const subscriptionsGetManagementPortal = <ThrowOnError extends boolean = false>(
  options?: Options<SubscriptionsGetManagementPortalData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SubscriptionsGetManagementPortalResponse,
    SubscriptionsGetManagementPortalError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/manage_portal',
    ...options,
  });
};

export const subscriptionsGetMySubscription = <ThrowOnError extends boolean = false>(
  options?: Options<SubscriptionsGetMySubscriptionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SubscriptionsGetMySubscriptionResponse,
    SubscriptionsGetMySubscriptionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me',
    ...options,
  });
};

export const subscriptionsCancelMySubscription = <ThrowOnError extends boolean = false>(
  options: Options<SubscriptionsCancelMySubscriptionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, SubscriptionsCancelMySubscriptionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const subscriptionsChangeSubscription = <ThrowOnError extends boolean = false>(
  options: Options<SubscriptionsChangeSubscriptionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SubscriptionsChangeSubscriptionResponse,
    SubscriptionsChangeSubscriptionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me/change',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const subscriptionsCancelSubscriptionChange = <ThrowOnError extends boolean = false>(
  options: Options<SubscriptionsCancelSubscriptionChangeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SubscriptionsCancelSubscriptionChangeResponse,
    SubscriptionsCancelSubscriptionChangeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me/change/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const subscriptionsGetChangePreview = <ThrowOnError extends boolean = false>(
  options?: Options<SubscriptionsGetChangePreviewData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SubscriptionsGetChangePreviewResponse,
    SubscriptionsGetChangePreviewError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me/change_preview',
    ...options,
  });
};

export const subscriptionsGetMyExpiredSubscription = <ThrowOnError extends boolean = false>(
  options?: Options<SubscriptionsGetMyExpiredSubscriptionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SubscriptionsGetMyExpiredSubscriptionResponse,
    SubscriptionsGetMyExpiredSubscriptionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/subscriptions/me/expired',
    ...options,
  });
};

/**
 * BatchGetMemberCreditsInfo 批量查询多个成员的积分信息。
 * 用于成员列表页展示消耗积分数和剩余积分数。
 */
export const memberCreditsBatchGetMemberCreditsInfo = <ThrowOnError extends boolean = false>(
  options: Options<MemberCreditsBatchGetMemberCreditsInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MemberCreditsBatchGetMemberCreditsInfoResponse,
    MemberCreditsBatchGetMemberCreditsInfoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/team/members/credits/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * BatchConfigureMemberCredits 批量配置成员积分（分配或回收），单事务，整批成功或整批失败。
 * 通过 op_type 区分分配（allocate）和回收（recover）操作。
 * 同一批次只能包含同一种操作类型。
 */
export const memberCreditsBatchConfigureMemberCredits = <ThrowOnError extends boolean = false>(
  options: Options<MemberCreditsBatchConfigureMemberCreditsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MemberCreditsBatchConfigureMemberCreditsResponse,
    MemberCreditsBatchConfigureMemberCreditsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/team/members/credits/configure',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetMemberCreditsInfo 查询单个成员的剩余积分和已消耗积分。
 * 已消耗积分 = 该成员所有消费类 credit_records 的绝对值之和（排除分配/回收记录）。
 */
export const memberCreditsGetMemberCreditsInfo = <ThrowOnError extends boolean = false>(
  options: Options<MemberCreditsGetMemberCreditsInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    MemberCreditsGetMemberCreditsInfoResponse,
    MemberCreditsGetMemberCreditsInfoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/team/members/{member_user_id}/credits',
    ...options,
  });
};

export const trialsGet = <ThrowOnError extends boolean = false>(options?: Options<TrialsGetData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<TrialsGetResponse, TrialsGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/trials/me',
    ...options,
  });
};

export const trialsBatchGet = <ThrowOnError extends boolean = false>(
  options?: Options<TrialsBatchGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TrialsBatchGetResponse, TrialsBatchGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/trials/me/all',
    ...options,
  });
};
